import { useEffect, useState } from 'react'
import { ImagePlus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  currentImage: string | null
  file: File | null
  removed: boolean
  copy: FdeCopy
  onChange: (file: File | null, removed: boolean) => void
}

export default function ProfileImageField({ currentImage, file, removed, copy, onChange }: Props) {
  const [preview, setPreview] = useState<string | null>(removed ? null : currentImage)

  useEffect(() => {
    if (!file) {
      setPreview(removed ? null : currentImage)
      return
    }

    const objectUrl = URL.createObjectURL(file)
    setPreview(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [currentImage, file, removed])

  return <div className="rounded-lg border border-border bg-muted/15 p-4">
    <Label htmlFor="fde-profile-image">{copy.forms.photo}</Label>
    <div className="mt-2 flex items-center gap-3">
      <div className="flex size-16 shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-background text-muted-foreground">
        {preview ? <img src={preview} alt="" className="size-full object-cover" /> : <ImagePlus className="size-5" />}
      </div>
      <div className="min-w-0 flex-1">
        <Input id="fde-profile-image" type="file" accept="image/jpeg,image/png,image/webp" onChange={(event) => onChange(event.target.files?.[0] || null, false)} />
        <p className="mt-1 text-[11px] text-muted-foreground">{copy.forms.photo_hint}</p>
      </div>
      {preview && <Button type="button" size="icon-sm" variant="ghost" onClick={() => onChange(null, true)} aria-label={copy.forms.remove_photo}><Trash2 className="size-4" /></Button>}
    </div>
  </div>
}
